import styled from 'styled-components/macro';
import { Centered } from '../../../styles/helpers.styles';

export const IconHolder = styled.span`
  ${Centered}
  background: var(--white);
  width: 36px;
  height: 36px;
  color: var(--primary);
  border-radius: 100%;
  font-size: var(--font-size-base);
  margin-bottom: 10px;
`;
